import axios from "@/api/axios";

const getSettings1c = (data) => {
    return axios
        .post('/admin/uis/get-settings1c', data)
        .then(response => response.data)
}

const getSettings = (data) => {
    return axios
        .post('/admin/uis/get-settings', data)
        .then(response => response.data)
}

const callOut = (data) => {
    return axios
        .post('/admin/uis/call-out', data)
        .then(response => response.data)
}

const getUnits = (data) => {
    return axios
        .post('/admin/uis/get-units', data)
        .then(response => response.data)
}

export default {
    getSettings1c,
    getSettings,
    callOut,
    getUnits
}